module.exports = __webpack_public_path__ + "static/media/PDF_96.a1dc78ef.pdf";